/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkOnetimepassword } from '../models/work-onetimepassword';

@Injectable({ providedIn: 'root' })
export class WorkOnetimepasswordsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `onetimepasswordsV2ControllerFindByContactId()` */
  static readonly OnetimepasswordsV2ControllerFindByContactIdPath = '/v2/onetimepasswords/byContactId/{contactId}';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `onetimepasswordsV2ControllerFindByContactId()` instead.
   *
   * This method doesn't expect any request body.
   */
  onetimepasswordsV2ControllerFindByContactId$Response(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkOnetimepassword>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOnetimepasswordsV2Service.OnetimepasswordsV2ControllerFindByContactIdPath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkOnetimepassword>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `onetimepasswordsV2ControllerFindByContactId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  onetimepasswordsV2ControllerFindByContactId(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkOnetimepassword>> {
    return this.onetimepasswordsV2ControllerFindByContactId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkOnetimepassword>>): Array<WorkOnetimepassword> => r.body)
    );
  }

}
